import styles from "./RoundBadge.module.css"

const RoundBadge = ({ value, color, small, style = {}, children }) => {

  return (
    <div className={small ? `${styles.roundBadge} ${styles.small}` : styles.roundBadge} style={{
      "--accent-color": color,
      ...style
    }}>
      {value ?? children}
    </div>
  )
}

export default RoundBadge
